import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import Font from '@maxpreps/shared/styles/font';
import styled from 'styled-components';
import useToggle from '../../hooks/useToggle';
import THEME, { COLOR } from '../../styles/colors';
import Icon, { SportIcon } from '../../ui/Icon/Icon';
import StyledAnchor from '../../ui/StyledAnchor/StyledAnchor';
import StyledText from '../../ui/Text/StyledText';
import Anchor from '../Anchor/Anchor';

interface IStyledSubMenuProps {
  $isOpen?: boolean;
}

const StyledFlyoutSubList = styled.ul<IStyledSubMenuProps>`
  padding: 0;
  margin: 0;
  ${({ $isOpen }) => !$isOpen && 'display: none;'}
`;

const StyledFlyoutSubListItem = styled(StyledAnchor)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${COLOR.black};
  padding: 10px 0 10px 16px;

  &:hover {
    color: ${THEME.brand.maxpreps};
  }
`;

const StyledFlyoutSubHeader = styled.div<IStyledSubMenuProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  & .item-text {
    padding: 10px 0;
  }

  & svg {
    transition: all 0.15s ease-in-out 0s;
    transform: rotate(${({ $isOpen }) => ($isOpen ? 180 : 90)}deg);
  }
`;

interface IFlyoutSubListItemProps {
  linkData: any;
}

const FlyoutSubListItem: React.FC<IFlyoutSubListItemProps> = ({ linkData }) => {
  const { text, iconId, iconType, href } = linkData;

  let icon;
  if (iconType === 'sport') {
    icon = <SportIcon iconId={iconId} size={24} />;
  }

  // (Ryan - 12/9/2020) only reason i plugged 'href.replace' is to fix a SSR/CSR render bug
  // The sport photos link has 'https://dev.maxpreps.com/photography/browse-galleries?sport=basketball&state=all states'
  // the space needs to be query param encoded.
  // I'm trying to find a bigger bug is why i'm hack fixing this but we should get a ticket in to resolve sometime down the road.
  return (
    <li key={text}>
      {icon}
      <StyledFlyoutSubListItem
        href={href.replace(' ', '%20')}
        $marginLeft="12px"
        $width="100%"
        className={Font.f14_bold_tall}
      >
        {text}
      </StyledFlyoutSubListItem>
    </li>
  );
};

interface IHamburgerSubMenuProps {
  text: string;
  href: string;
  subItems?: any[];
}

const HamburgerSubMenu: React.FC<IHamburgerSubMenuProps> = ({
  text,
  href,
  subItems
}) => {
  const [isOpen, toggleOpen] = useToggle(false);

  return (
    <>
      <StyledFlyoutSubHeader onClick={toggleOpen} $isOpen={isOpen}>
        {href ? (
          <Anchor
            className={`item-text ${Font.f16_bold_tall}`}
            $hoverColor={THEME.brand.maxpreps}
            $width="100%"
            href={href}
          >
            {text}
          </Anchor>
        ) : (
          <StyledText
            className={`item-text ${Font.f16_bold_tall}`}
            $hoverColor={THEME.brand.maxpreps}
            $width="100%"
          >
            {text}
          </StyledText>
        )}
        <Icon icon={faChevronUp} color={COLOR.black} size={18} />
      </StyledFlyoutSubHeader>
      {subItems && (
        <StyledFlyoutSubList $isOpen={isOpen}>
          {subItems.map(link => (
            <FlyoutSubListItem linkData={link} key={link.text} />
          ))}
        </StyledFlyoutSubList>
      )}
    </>
  );
};

export default HamburgerSubMenu;
